import styled from 'styled-components';
import colors from '../../../../includes/colors';

export const QuestionTitle = styled.a`
  margin-left: 0;
  color: ${colors.blue} !important;
  font-size: 1rem;
  width: 100%;
  position: relative;
  list-style: none;
  display: block;
  width: 100%;
  font-size: 0.875rem;
  cursor: pointer;
  &:hover {
    color: ${colors.darkBlue} !important;
  }
  .dds__icons {
    display: block;
    position: absolute;
    font-weight: 900;
    left: 0px;
    top: 3px;
    transform: rotate(0deg);
    font-size: 0.875rem;
    transition: all 0.25s ease;
    @media (min-width: 768px) {
      top: 50%;
      margin-top: -0.53rem;
    }
  }
  &.active {
    .dds__icons {
      transform: rotate(90deg) !important;
    }
  }
`;

export const QuestionText = styled.p`
  font-size: 0.875rem;

  a {
    text-decoration: underline;
  }
`;
